import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CloseButton from './CloseButton';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(0.5, 1),
  },
  closeButton: {},
});

const Actions = ({
  className,
  classes,
  onClose,
  showCloseIcon,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {(showCloseIcon && onClose) ? (
        <CloseButton
          className={classes.closeButton}
          onClose={onClose}
        />
      ) : null}
    </Box>
  );
};

Actions.defaultProps = {
  className: '',
};

Actions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  showCloseIcon: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Actions);
